import { Accordion, AccordionDetails, AccordionSummary, Divider, Grid } from '@mui/material'
import InstallationAction from 'installation/actions/InstallationAction'
import { groupBy } from 'lodash'
import React from 'react'
import { useDispatch } from 'react-redux'
import i18n from 'simple-react-i18n'
import PropTypes from 'prop-types'
import { getI18nTitleDataLength } from 'utils/StringUtil'
import { getName } from 'pgsse/util/PgsseUtil'

const SectionPanel = ({
    color = '',
    entities = [],
    expanded = false,
    title='',
}) => {
    const dispatch = useDispatch()

    return (
        <Accordion defaultExpanded={expanded}>
            <AccordionSummary
                sx={{
                    backgroundColor: color,
                }}
            >
                {title}
            </AccordionSummary>
            <AccordionDetails>
                <Grid container direction={'column'}>
                    {entities.map((e, index) => {
                        const { icon, text } = getName(e)

                        return (
                            <Grid
                                key={e.code}
                                container
                                className={`${e.hasDiagnostic && 'clickable'}`}
                                onClick={() => {
                                    if (e.link_dangers.length) {
                                        dispatch(InstallationAction.fetchDanger(e.link_dangers[0].idDanger))
                                    } else if (e.hasDiagnostic) {
                                        dispatch(InstallationAction.fetchVisit(e.siteCode, e.idCampaign))
                                    }
                                }}
                            >
                                <Grid container size={12} style={{ padding: '5px 10px' }}>
                                    <Grid style={{ paddingTop: '8px' }}>{icon}</Grid>
                                    <Grid alignItems='center' className='padding-left-1' style={{ fontSize: '16px' }}>
                                        <Grid size={12} className='bold'>
                                            {text}
                                        </Grid>
                                        <Grid size={12}>
                                            {`${e.link_dangers.length} ${getI18nTitleDataLength(i18n.dangerousSituation, i18n.dangerousSituations, e.link_dangers.length)}`}
                                        </Grid>
                                    </Grid>
                                </Grid>
                                {index + 1 !== entities.length && (
                                    <Grid size={12}>
                                        <Divider />
                                    </Grid>
                                )}
                            </Grid>
                        )
                    })}
                </Grid>
            </AccordionDetails>
        </Accordion>
    )
}

SectionPanel.propTypes = {
    color: PropTypes.string,
    entities: PropTypes.shape([]),
    expanded: PropTypes.bool,
    title: PropTypes.string,
}

const PgsseEntityPanel = ({
    data = {},
}) => {
    const groupedData = groupBy(data, 'color')

    return (
        <Grid
            container
            className='padding-top-1'
            direction={'column'}
            gap={1}
        >
            <Grid size={12}>
                <SectionPanel
                    color={'red'}
                    entities={groupedData.red}
                    expanded
                    title={i18n.highRisk}
                />
            </Grid>
            <Grid size={12}>
                <SectionPanel
                    color={'orange'}
                    entities={groupedData.orange}
                    title={i18n.mediumRisk}
                />
            </Grid>
            <Grid size={12}>
                <SectionPanel
                    color={'green'}
                    entities={groupedData.green}
                    title={i18n.lowRisk}
                />
            </Grid>
            <Grid size={12}>
                <SectionPanel
                    color={'blue'}
                    entities={groupedData.blue}
                    title={i18n.notEvaluatedHazards}
                />
            </Grid>
            <Grid size={12}>
                <SectionPanel
                    color={'grey'}
                    entities={groupedData.grey}
                    title={i18n.noDiagnostic}
                />
            </Grid>
        </Grid>
    )
}

PgsseEntityPanel.propTypes = {
    data: PropTypes.shape({}),
}

export default PgsseEntityPanel
